
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { ChapterMetadata, TutorialMetadata } from '@/utils/sample-data';

interface ChapterPaginationProps {
  tutorial: TutorialMetadata;
  currentChapterSlug: string;
}

export function ChapterPagination({ tutorial, currentChapterSlug }: ChapterPaginationProps) {
  const currentChapterIndex = tutorial.chapters.findIndex(
    chapter => chapter.slug === currentChapterSlug
  );
  
  const prevChapter = currentChapterIndex > 0 
    ? tutorial.chapters[currentChapterIndex - 1]
    : null;
    
  const nextChapter = currentChapterIndex < tutorial.chapters.length - 1
    ? tutorial.chapters[currentChapterIndex + 1]
    : null;

  return (
    <div className="flex justify-between items-center mt-8 pt-8 border-t">
      <div>
        {prevChapter && (
          <Link to={`/tutorials/${tutorial.id}/chapters/${prevChapter.slug}`}>
            <Button variant="outline" className="flex items-center gap-2">
              <ArrowLeft className="h-4 w-4" />
              <div className="flex flex-col items-start">
                <span className="text-xs text-muted-foreground">Previous</span>
                <span className="text-sm">{prevChapter.title}</span>
              </div>
            </Button>
          </Link>
        )}
      </div>
      <div>
        {nextChapter && (
          <Link to={`/tutorials/${tutorial.id}/chapters/${nextChapter.slug}`}>
            <Button variant="outline" className="flex items-center gap-2">
              <div className="flex flex-col items-end">
                <span className="text-xs text-muted-foreground">Next</span>
                <span className="text-sm">{nextChapter.title}</span>
              </div>
              <ArrowRight className="h-4 w-4" />
            </Button>
          </Link>
        )}
      </div>
    </div>
  );
}
